import styled from "styled-components"


export const Card = styled.div`
  background-color: white;
  min-width: 300px;
  width: 45%;
  max-height: 600px;
  min-height: 550px;
  height: 65vh;
  display:flex;
  justify-content: center;
`;

export const ImgLogo = styled.img`
  width: 30%;
  height: 40%;
  display: flex;
  align-items: center;
`;
